import {
  Box,
  CircularProgress,
  InputAdornment,
  List,
  makeStyles,
  TablePagination,
  TextField,
  Typography,
  Checkbox,
} from "@material-ui/core";
import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../../context";
import { laboratoryServices } from "../../../../services";
import { SearchRounded } from "@material-ui/icons";
import UserListItem from "./UserItemList";
import { capitalizeFirstLetterArray } from "../../../../helpers";
export default function SelectRepresentative({
  assignments,
  addUser,
  removeUser,
  labRepresentative,
  setLabRepresentative,
}) {
  const { authState, signOut } = useContext(AuthContext);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();

  // useEffect(() => {
  //   console.log(selected);
  // }, [selected]);
  async function getLabRepresentatives() {
    try {
      const { status, response } =
        await laboratoryServices.getAssociatedUsersByLab({
          getOptions: {
            roles: ["representatives"],
            ascending: true,
            limit,
            page,
          },
          laboratoryId: authState.user.laboratory._id,
          token: authState.token,
        });

      if (status === 200) {
        setLabRepresentative(response.response.data);
        setLimit(response.response.limit);
        setCount(response.response.total);
        setPage(response.response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getLabRepresentatives();
  }, [limit, page]);
  return (
    <Box mt={2}>
      <Box>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRounded />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box className={classes.content_list_product}>
        <List dense className={classes.list_product}>
          {loading ? (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          ) : (
            labRepresentative?.map((r) => {
              const isDisabled = r.status !== "active";
              return (
                <UserListItem
                  key={r._id}
                  disabled={isDisabled}
                  name={capitalizeFirstLetterArray(
                    `${r.firstName} ${r.lastName}`
                  )}
                  rut={r.rut}
                  zones={r.zones}
                  contentListItemIcon={
                    <Checkbox
                      checked={assignments[r._id] ? true : false}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        if (checked) addUser(r._id, {});
                        else removeUser(r._id);
                      }}
                      edge="start"
                      disabled={isDisabled}
                      disableRipple
                    />
                  }
                ></UserListItem>
              );
            })
          )}
          {!loading && labRepresentative.length === 0 && (
            <Box
              style={{ display: "flex", justifyContent: "center", padding: 12 }}
            >
              <Typography>
                No hay datos que correspondan con su busqueda.
              </Typography>
            </Box>
          )}
        </List>
      </Box>
      <Box display="flex" justifyContent={"end"}>
        <TablePagination
          labelRowsPerPage="Cant."
          component="div"
          count={count}
          onRowsPerPageChange={(e) => setLimit(e.target.value)}
          onPageChange={(e, page) => setPage(page + 1)}
          page={page - 1}
          rowsPerPage={limit}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  content_list_product: {
    height: "56vh",
    overflowY: "auto",
  },
  list_product: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))",
    gap: theme.spacing(2),
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),

    "& li": {
      boxShadow: theme.shadows[1],
      marginTop: theme.spacing(1),
      borderRadius: theme.spacing(2),
    },
  },
}));
